<div>
  @if ($initAuthInProgress() || $languageChangeInProgress()) {
    <app-view-loader />
  }
  <router-outlet />
</div>
